export const technology = (translation) => [
  translation("filter.all"),
  "JavaScript",
  "React JS",
  "SCSS",
  "TanStack Query",
  "Redux",
  "Angular v13",
  "Node JS",
  "Express JS",
  "MongoDB",
  "PostgreSQL",
];

export const category = (translation) => [
  translation("filter.all"),
  translation("filter.projects"),
  translation("filter.apps"),
];
